import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {environment} from '@env/environment';
import {WindowUiSetup} from '@app/core/util/WindowUiSetup';
import {CoreModule} from '@app/core/CoreModule';

// apply environment
if (environment.production) {
    enableProdMode();
}

// perform bootstrap
platformBrowserDynamic().bootstrapModule(CoreModule).then(() => WindowUiSetup.apply()).catch(console.error);
